import React, { useEffect, useState } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { useLocale } from './LocaleContext';

// Clerk's sign-in and sign-up in the page's language. Each translation is
// ~48 KB, so it is fetched only for a visitor who reads the site in it.
const LOADERS = {
  es: () => import('@clerk/localizations/es-MX').then((m) => m.esMX),
  pt: () => import('@clerk/localizations/pt-BR').then((m) => m.ptBR),
  fr: () => import('@clerk/localizations/fr-FR').then((m) => m.frFR),
  de: () => import('@clerk/localizations/de-DE').then((m) => m.deDE),
  // Clerk has Modern Standard Arabic only, and leaves its field hints in English; its
  // forms read right to left with the page
  ar: () => import('@clerk/localizations/ar-SA').then((m) => ({
    ...m.arSA,
    formFieldInputPlaceholder__emailAddress: 'اكتب إيميلك',
    formFieldInputPlaceholder__emailAddress_username: 'اكتب إيميلك أو اسم المستخدم',
    formFieldInputPlaceholder__password: 'اكتب الباسورد',
    formFieldInputPlaceholder__firstName: 'اسمك الأول',
    formFieldInputPlaceholder__lastName: 'اسم العيلة',
  })),
};

export default function LocalizedClerkProvider({ publishableKey, children }) {
  const { locale } = useLocale();
  const [localization, setLocalization] = useState({ locale: 'en', value: undefined });

  useEffect(() => {
    if (!LOADERS[locale]) {
      setLocalization({ locale, value: undefined });
      return undefined;
    }
    let cancelled = false;
    LOADERS[locale]()
      .then((value) => { if (!cancelled) setLocalization({ locale, value }); })
      .catch(() => {}); // English forms rather than none
    return () => { cancelled = true; };
  }, [locale]);

  return (
    <ClerkProvider publishableKey={publishableKey} localization={localization.value}>
      {children}
    </ClerkProvider>
  );
}
